import { type Duration, hoursToSeconds } from 'date-fns';
import { IS_PRODUCTION } from './environment';

export const LANGUAGE_CODE_HEADER = 'x-language-code';
export const SESSION_INFO_HEADER = 'session-info';

export const DEFAULT_OFFERING = 'default';
export const PAYWALL_CACHE_TIME = hoursToSeconds(6);

export const APP_DOWNLOAD_EVENT_NAME = 'app_download-clicked';

export const ADJUST_DOWNLOAD_LINK_TRACKER_TOKEN = '1tw9b3on';
export const ADJUST_DOWNLOAD_LINK_TRACKER_NAME = 'Organic Web';
export const ADJUST_DOWNLOAD_LINK_CAMPAIGN_NAME = 'Galatea-Web';
export const ADJUST_DOWNLOAD_LINK = `https://galatea.go.link/?adj_t=${ADJUST_DOWNLOAD_LINK_TRACKER_TOKEN}&adj_campaign=${ADJUST_DOWNLOAD_LINK_CAMPAIGN_NAME}`;

export const CACHE_WEB_SUBSCRIPTION_TIME: Duration = {
  hours: 1,
};

export const DEFAULT_WAIT_TIME = 360;
export const DEFAULT_POINTS_TO_UNLOCK = 10;
export const COUNTDOWN_UPDATE_INTERVAL = 1000;
export const TIMER_EXPIRED_VALUE = '00:00:00';

const ONE_HOUR = 1000 * 60 * 60;
export const ONE_DAY = ONE_HOUR * 24;

export const IOS_APP_LINK = 'https://apps.apple.com/us/app/galatea-books-audiobooks/id1380362212';
export const GALATEA_APP_STORE_ID = '1380362212';
export const ANDROID_APP_LINK = 'https://play.google.com/store/apps/details?id=com.colt';

export const ALLOWED_LISTS_LOCALES = ['en', 'fr', 'de', 'it', 'es', 'pt', 'pl', 'tr'];

/**
 * This is a temporary mapping to partially secure free trial days information from app 2 web.
 * Instead of passing freeTrialDays in query params - which is unsecure and can allow any arbitrary value
 * We are passing a purchase code which is a string that is known to the app and web.
 * The code below was randomly generated.
 */
export { PURCHASE_CODE_TO_FREE_TRIAL_DAYS } from '@inkitt/contracts-galatea';

export const GTM_ID = 'GTM-TR8NSQ7';

// Production-only: tags in the container (podscribe, pixels) persist visited URLs in device
// storage and replay them to third parties, so loading it on staging/dev leaks internal URLs —
// including basic-auth credentials embedded in staging links (DEV-5904).
export const GTM_CONFIG: { id: string } | undefined = IS_PRODUCTION ? { id: GTM_ID } : undefined;
export const ADJUST_APP_TOKEN = 'iznchqz6bzeo';

export const CONSENT_MANAGER_ID = IS_PRODUCTION ? '85119c0b02d7d' : 'c9973e0b922a9';
export const CONSENT_MANAGER_HOST = 'a.delivery.consentmanager.net';
